'use client';
import clsx from 'clsx';
import {useEffect, useRef} from 'react';

type CosmicArtifactProps = {
  size: 'sm' | 'md' | 'lg' | 'xl';
};

export default function CosmicArtifact(props: CosmicArtifactProps) {
  const artifactRef = useRef<HTMLDivElement>(null);

  // Apply random animation delay on client-side only
  useEffect(() => {
    if (artifactRef.current) {
      artifactRef.current.style.animationDelay = `${Math.random() * -3}s`;
    }
  }, []);

  return (
    <div
      ref={artifactRef}
      className={clsx(
        'rounded-full animate-[float_6s_ease-in-out_infinite]',
        props.size === 'sm' && 'w-10 h-10',
        props.size === 'md' && 'w-20 h-20',
        props.size === 'lg' && 'w-32 h-32',
        props.size === 'xl' && 'w-40 h-40'
      )}
      style={{
        background:
          'radial-gradient(circle, rgba(109, 40, 217, 0.4) 0%, rgba(109, 40, 217, 0.05) 70%)'
      }}
    ></div>
  );
}

// Add a custom animation for the artifacts
const customStyles = `
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
`;

// Add the custom styles to the document
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = customStyles;
  document.head.appendChild(style);
}
